export default function SchedulesPage() {
  return (
    <div>
      <h1 style={{ fontSize: '1.8rem', fontWeight: 700, color: '#1a1c2c', marginBottom: '1rem' }}>
        📅 Horarios
      </h1>
      <p style={{ color: '#888' }}>Gestión de horarios pendiente de implementación.</p>
    </div>
  );
}
